import StripeBadgeAlert from "./stripe-badge-alert";
export default StripeBadgeAlert;
